/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/**
 * A module representing the Enum data type.
 * @module utilities/types/Enum
 */
"use strict";

var _freeze = require("babel-runtime/core-js/object/freeze");

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = require("lodash");
var deprecate = require("depd")("@auex/utilities");
var FunctionCallError = require("../errors").FunctionCallError;
var MissingParameterError = FunctionCallError.MissingParameterError;
var InvalidParameterError = FunctionCallError.InvalidParameterError;

/**
 * Enumeration of values. Often used to describle possible values of a state
 * variable.
 * @param {Array} values Array of Strings that will be assigned a value in
 *                       order. (Starting at 0)
 */
function Enum(values) {
  deprecate("'Enum' is deprecated in this module. Please use" + " '@novivia/utilities/types/Enum' instead.");

  if (_.isUndefined(values)) {
    throw new MissingParameterError(null, "You need to instanciate Enum with an Array of Strings.");
  }

  if (!_.isArray(values)) {
    throw new InvalidParameterError(null, "You need to instanciate Enum with an Array of Strings.", values);
  }

  var self = this;

  this._values = values;
  this.length = this._values.length;

  _.forEach(this._values, function valuesToSelf(value, index) {
    self[value] = index;
  });

  (0, _freeze2.default)(this);
}

/**
 * Returns the maximum possible value for the Enum.
 * @return {Number} Biggest value in the Enum. (Last one)
 */
Enum.prototype.getMax = function getMax() {
  return this.length - 1;
};

/**
 * Returns the original Array provided to create the Enum.
 * @return {Array} Array of Strings initially provided to the constructor.
 */
Enum.prototype.getList = function getList() {
  return this._values;
};

/**
 * Returns the mapping between the original Array provided to create the Enum
 * and the associated numerical value.
 * @return {Object} Object literal with the Enum values mapping.
 */
Enum.prototype.getMapping = function getMapping() {
  var self = this;

  return this._values.reduce(function reduceValues(values, value) {
    values[value] = self[value];

    return values;
  }, {});
};

/**
 * Returns the list of possible numerical values for the Enum.
 * @return {Array} Array of possible numerical values for the Enum.
 */
Enum.prototype.getValues = function getValues() {
  var self = this;

  return this._values.map(function mapValues(value) {
    return self[value];
  });
};

module.exports = exports = Enum;


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/types/Enum.js
// module id = 878
// module chunks = 6